import adapter from './tagAdapter';
import Customer2FaTag from './tagJsonDinamics';
import Analytics from '../Analytics';
import {TagType,TagTypeGa4} from './tagType';
import { getUrlParams } from "core/Utils/getUrlParams";
import tagAdapter from './tagAdapter';

function getJsonTag(config={},type="") {
  const client_id = getUrlParams("client_id");
  //validar client id
  config.tipo_origem=client_id

  const tagJsonDinamics = Customer2FaTag(config)

  const configTag= tagJsonDinamics.customer2fa[type]
  const defaultTag= tagJsonDinamics.customer2fa.default
  const tagReturn={
    ...defaultTag,
    ...configTag
  }

  return tagReturn
}



//FIXME: Remover quando for implementar no meu perfil || Mudar o nome da função
function inputFactory(label, currentFlow, event) {

  if(currentFlow==="customer2fa"){
    tagAdapter({nome_item:label},TagTypeGa4.INPUT)
  }
  else{
  Analytics().setInputEvent(label, currentFlow, event);
  }
}

//FIXME: Remover quando for implementar no meu perfil || Mudar o nome da função
function atributteFactory(currentFlow,eventCategory, eventAction,label) {

let json={ 
  "data-gtm-event-category":eventCategory,
  "data-gtm-event-action":eventAction,
  "data-gtm-event-label":label
}

  if(currentFlow==="customer2fa"){
      json={}
    }
    return json
  
}

export {getJsonTag,inputFactory,atributteFactory}